import { Observable, Subject, ReplaySubject } from 'rxjs';
import { AgregationService, ReplaceActionService } from '../services';
import { IdataBinding, IconfigDataAction, IconfigBinding } from '../interfaces';
import {select, Store} from '@ngrx/store';
import { isEmpty, filter as lodashFilter, get, set, remove,findIndex } from 'lodash';
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';
import { isEqual, cloneDeep, differenceWith } from 'lodash';
import { distinctUntilChanged, takeUntil, filter, tap, map } from 'rxjs/operators';
import { CONFIGBINDING_ACTION_TYPES } from '../services/consts';
import {selectConfigBindings, selectDataBindings} from "@ispm/dynamic-form/store/form.selectors";
import { FlattenService } from "@ispm-client/modules/aggregator/services";
import {IconfigItem, IdynamicFormItem} from "@ispm/dynamic-form/interfaces/IdynamicFormItem";

export abstract class AsyncLoaderClass {
  protected dataob$: ReplaySubject<any> = new ReplaySubject(1);
  protected formsdataBinding$: Observable<any>;
  private itemConfigBinding$: Observable<any>;
  private asyncdestroyer: Subject<any> = new Subject();
  private enityTreeData: Map<string, any>;
  private identifier: string;
  protected _dataBindings: Array<IdataBinding>;
  private configBindingData: Map<string, Array<any>> = new Map();
  protected abstract onBundleSubscribe(data: object, itemKey?: string, isFromConfigBinding?: boolean, isDataReset?: boolean, updateFromDataBindings?: boolean): void;
  protected abstract onConfigSetToOptions(options: any, identifierKey: string): void;
  protected abstract onConfigSetToConfig(data: object, identifierKey: string): void;
  constructor(protected _queryAgregator: AgregationService, store: Store<IgenomicsState>, public flattenService: FlattenService) {
    this.formsdataBinding$ = store.pipe(select(selectDataBindings));
    this.itemConfigBinding$ = store.pipe(select(selectConfigBindings));
    }
  /**
   *
   * @param dataBindingIdentifier
   * This function is should be called the child class
   * is ready with dataBinding Identifier and thinks the
   * databinding is/will be in store
   */
  public init(dataBindingIdentifier: string) {
    this.identifier = dataBindingIdentifier;
    this.formsdataBinding$.pipe(
      takeUntil(this.asyncdestroyer.asObservable()),
      tap(dataBindings => {
      if (isEmpty(dataBindings.get(this.identifier))) {
        this.dataob$.next(null);
      }
    }),
      takeUntil(this.asyncdestroyer.asObservable()),
      filter((data) => data.has(this.identifier)),
      map((data) => data.get(this.identifier)),
      distinctUntilChanged())
      .subscribe(data => {
        this.internalRegister(cloneDeep(data));
      });
  }

  /** ngDocheck is costly function also databinding is one time;
   set function is used because if dataBindings set by extended class it should register */
  set dataBindings(_dataBindings: Array<IdataBinding>) {
    this.internalRegister(_dataBindings);
  }

  /** Currently not being used if explicitly registration by the
   *  component which extends */
  public externalRegister(_dataBindings: Array<IdataBinding>) {
    return this._queryAgregator.registerQuery(_dataBindings);
  }

  private internalRegister(_dataBindings: Array<IdataBinding>) {
    this._dataBindings = _dataBindings;
    if (_dataBindings !== undefined && _dataBindings !== null) {
      let firstIteration = true;
      /**
       * For databing which are having prefetch false should be interpolated
       * with data returned from databindings prefetch true
       *
       **/
      // TODO find a single line logic by filter and/or omit
      const prefetch = lodashFilter(_dataBindings, function(o) { return ((o.prefetch === true) || (!o.hasOwnProperty('prefetch'))); });
      const interpolateAndfetch = lodashFilter(_dataBindings, function(o) {
        return  (o.hasOwnProperty('isDepandant') && (o.isDepandant === true)); });
      const noRestCallPickFromExisting = lodashFilter(_dataBindings, function(o) { return o.hasOwnProperty('pickerIdentifierPath'); });
      const resultinterpolateAndfetch = differenceWith(interpolateAndfetch, noRestCallPickFromExisting, isEqual);
      const actualPrefetch = differenceWith(prefetch, interpolateAndfetch, isEqual);
      this._queryAgregator.registerQuery(actualPrefetch)
        /** Using filter below to avoid repainting the dynamic form if data was
        * same as what it recieved last time
        */
        .filter((val) => {
          let dataValuesMap = new Map(Object.entries(Object.assign({}, ...val)));
          let isSimilarData = isEqual(dataValuesMap, this.enityTreeData);
          return !isSimilarData;
        }).
        pipe(takeUntil(this.asyncdestroyer.asObservable()))
        .subscribe((data) => {
          /** Not sure whether observable should be returned directly/Assining the form itself here
              As from array to object same identifier data will be lost
              Achieving distinct via varibale should do it differently
              */
          let responseData = Object.assign({ }, ...cloneDeep(data));
          this.enityTreeData = new Map(Object.entries(responseData)); // this field can also be used later to get meta and id info of all
          // if ((resultinterpolateAndfetch.length > 0) && this._queryAgregator.isDeepEmpty(responseData, [{}])) {
            if (resultinterpolateAndfetch.length > 0) {
            if (firstIteration) {
              firstIteration = false;
              // No serving of half iteration of data
             // this.onBundleSubscribe(this.copyFromAnotherIdentifier(responseData, this._dataBindings));
              this.interpolateAndRegister(resultinterpolateAndfetch, responseData, false);
            } else {
             // this.onBundleSubscribe(this.copyFromAnotherIdentifier(responseData, this._dataBindings));
              this.retriggerDepandant(actualPrefetch, resultinterpolateAndfetch, responseData);
            }

          } else {
            // This is logic below is specifically used by Events alone needs revisiting
            if (noRestCallPickFromExisting.length) {
              const noRestData = this.pickDataFromLastDatabindingResponse(responseData, noRestCallPickFromExisting);
              const finalFormData  = Object.assign({ }, ...cloneDeep(noRestData));
              this.onBundleSubscribe(this.copyFromAnotherIdentifier(finalFormData, this._dataBindings), null, null, null, true);
              this.dataob$.next(null);
            }
            else {
              this.onBundleSubscribe(this.copyFromAnotherIdentifier(responseData, this._dataBindings), null, null, null, true);
              this.dataob$.next(null);
            }
          }
        });
    } else {
      this.dataob$.next(null);
    }
  }
  /**
   *
   * @param configBindingsdentifier form name
   * @param configIds current item ids
   * @param itemKey current item
   * @param interPolateData form data
   * This function will be used to have databinding on form item value change
   * basically this will be called by reflects or form item change
   */
  public registerValueChange(configBindingsdentifier: string, configIds: Array<IconfigItem | string>, itemKey: any, interPolateData: any, isInit : boolean = false) {
    // TODO in some cases form data may be empty but still you need call register
    if (this._queryAgregator.isDeepEmpty(interPolateData, [null, undefined])) {
      return;
    }
    if (configIds) {
      // Having subscribe here as register might have called by caller before the store has config bindings
      // Having init will reassign the configs but cant trigger the register
      this.itemConfigBinding$.take(1)
      .pipe(
        filter((data) => data.has(configBindingsdentifier)),
        map((data) => data.get(configBindingsdentifier)))
        .subscribe(configdataBindings => {
          this.registerConfigQueries(configdataBindings, configBindingsdentifier, configIds, itemKey, interPolateData,false ,isInit);
        });
    }
  }
  /**
   *
   * @param configBindings
   * @param configBindingsdentifier
   * @param configIds
   * @param itemKey
   * @param interPolateData
   * @param returnImmediatly
   * This function will be if config bindings are not in store reciecved as payload
   * for dynamically created form it will used as autogenerated form id as identifdier
   * unnecesserily creates more entry ofg same thing in store
   *
   */
  public registerConfigQueries(_configBindings: Array<IconfigBinding>, configBindingsdentifier: string,
    configIds: Array<IconfigItem | string>, itemKey: any, interPolateData: any, returnImmediatly = false,isInit : boolean = false): Observable<any> {
    /* console.log('registerValueChange formID', configBindingsdentifier);
     console.log('registerValueChange formData', configIds);
     console.log('registerValueChange interPolateData', interPolateData);*/
    const configBindings =  cloneDeep(_configBindings);
    if (configBindings) {
      const dataBindings: Array<IconfigBinding> = [];
      let tempdataBinding: IconfigBinding;
      configIds.forEach((configItem: any) => {
        if(configItem.hasOwnProperty('id')){
          tempdataBinding = configBindings.find(config => config.identifier === configItem.id && (!isInit || (isInit && configItem.runOnInit)));
        }else{
          tempdataBinding = configBindings.find(config => config.identifier === configItem)
        }

        if(!isEmpty(tempdataBinding)){
          tempdataBinding.queryString = this._queryAgregator.interpolate(tempdataBinding.queryString, interPolateData, true, {
            useEmptyValues: true,
            usePartialPath: false,
            clearUnresolvedPatterns: false
          });
          dataBindings.push(tempdataBinding);
        }
      });
      if (dataBindings.length > 0) {
        if (returnImmediatly) {
          return this._queryAgregator.registerQuery(dataBindings);
        }
        else {
          this._queryAgregator.registerQuery(dataBindings).pipe(takeUntil(this.asyncdestroyer.asObservable())).subscribe(data => {
            const responseData = Object.assign({ }, ...data);
            if (!(this._queryAgregator.isDeepEmpty(responseData, [null, undefined]))) {
              this.configActionResponseExecutor(dataBindings, responseData, configBindingsdentifier, itemKey);
            }
          });
        }
      }
      // below line will be removed after testing the config func
      /*setTimeout(function() { this.getConfigData(configBindingsdentifier, ['valueRange', 'testName']).
      subscribe(datas =>  {
        console.log('registerQuery formID', this.formId);
        console.log('registerQuery formData', this.formData);
        console.log('registerQuery interPolateData', interPolateData);
        console.log(datas);
      }); }.bind(this), 3000);*/
    }
  }

  setConfigDataToMap(configBindingsdentifier: string, data: any) {
    if (this.configBindingData.has(configBindingsdentifier)) {
      const datas = this.configBindingData.get(configBindingsdentifier);
      this.configBindingData.set(configBindingsdentifier, datas.concat(data));
    } else {
      this.configBindingData.set(configBindingsdentifier, data);
    }
  }

  private retriggerDepandant(_feederDatabindings: Array<IdataBinding>, _depandantDatabindings: Array<IdataBinding>, _interpolateObj: any) {
    const retriigerDepandants = this._queryAgregator.getretriggerDatabindings();
    const foundedIdentifier = retriigerDepandants.find((e) => e.identifier === _feederDatabindings[0].identifier)
    if (foundedIdentifier) {
      this.interpolateAndRegister(_depandantDatabindings, _interpolateObj, true);
      remove(retriigerDepandants, function (binding) {
        return binding.identifier === _feederDatabindings[0].identifier;
    });
    this._queryAgregator.setretriggerDatabindings(retriigerDepandants);
    }

  }

  public getConfigData(identifier: string, configIds: Array<string>): Observable<any> {
    const configData = { };
    const allItemData = Object.assign({ }, ...this.configBindingData.get(identifier));
    configIds.forEach(element => {
      configData[element] = allItemData[element];
    });
    return Observable.of(configData);
  }

  private interpolateAndRegister(dataBindings: Array<IdataBinding>, interpolateData: any, triggerDependant: boolean) {
    let interpolatedQueryString;
    // Passing the patient context also as during interpolation if interpolation data is not available it is set as Object object
    interpolateData = cloneDeep(Object.assign({ }, this._queryAgregator.getPatientContextId(), interpolateData));
    dataBindings.forEach(data => {
      data.queryString = this._queryAgregator.interpolate(data.queryString, interpolateData);
      interpolatedQueryString = data.queryString;
      if ((data.additionalFields) && (!(interpolatedQueryString.includes('&_fieldslist=')))) {
        interpolatedQueryString += '&_fieldslist=' + data.additionalFields;
      }
      data.interpolatedQuery = interpolatedQueryString;
    });
    this._queryAgregator.setPolatedDatabindings(dataBindings);
    /**
     * TODO Should not compare with enityTreeDatashould check whether
     * need to check enityTreeData has val and same
     */
    this._queryAgregator.ondemandRegister(dataBindings, triggerDependant).filter
    (val => !(isEqual(Object.entries(Object.assign({ }, ...val)), this.enityTreeData)))
      .pipe(takeUntil(this.asyncdestroyer.asObservable()))
      .subscribe((data) => {
        const oldObj = Array.from(this.enityTreeData).reduce((obj, [key, value]) => {
          obj[key] = value;
          return obj;
        }, { });
        const finalObj  = Object.assign({ }, oldObj, ...cloneDeep(data));
        this.enityTreeData = new Map(Object.entries(finalObj));
        this.onBundleSubscribe(this.copyFromAnotherIdentifier(finalObj, this._dataBindings), null, null, null, true);
        this.dataob$.next(null);
      });
  }

  private pickDataFromLastDatabindingResponse(response: any, queries: Array<IdataBinding>): Array<any> {
    let itemdata: any, tempdata: any;
    const returnData = [];
    queries.forEach((query) => {
      if (query.identifierType === 'array') {
        itemdata = [];
        if(query.pickerIdentifierType === 'object'){
          itemdata[query.identifier] = get(response, query.pickerIdentifierPath);
        }
        else {
          get(response, query.pickerIdentifierPath).forEach((element) => {
            if (element.formKey === query.identifier) {
              itemdata.push(Object.assign(element.data, {id: element.id, resourceType: element.resourceType}));
            }
          });
        }
        tempdata = { };
        tempdata[query.identifier] = itemdata;
        returnData.push(tempdata);
      } else {
        itemdata = Object.assign({ });
        if(query.pickerIdentifierType === 'object'){
          itemdata[query.identifier] = get(response, query.pickerIdentifierPath);
        }
       else{
          get(response, query.pickerIdentifierPath).forEach((element) => {
            if (element.formKey === query.identifier) {
              itemdata[query.identifier] = Object.assign(element.data, { id: element.id, resourceType: element.resourceType});
            }
          });
        }
        returnData.push(itemdata);
      }
    });
    return returnData;
  }

  OnDestroy(): void {
    this.asyncdestroyer.next();
    this.asyncdestroyer.complete();
  }
  /**
   *
   * @param _configBindings
   * @param _responseData
   * @param configIdentifier
   */
  private configActionResponseExecutor(_configBindings: Array<IconfigBinding>, _responseData: any,
                                      configIdentifier: string, itemKey: string) {
    _configBindings.forEach(element => {
      switch (element.dataAction.actionType) {
        case CONFIGBINDING_ACTION_TYPES.SET_TO_CONFIG: // add a setter which will call search again
          this.onConfigSetToConfig(get(_responseData, element.dataAction.dataFromPath), element.dataAction.targetItemName);
          break;
        case CONFIGBINDING_ACTION_TYPES.SET_TO_OPTIONS:
          this.onConfigSetToOptions({ resource: null, values:
                  get(_responseData, element.dataAction.dataFromPath)}, element.dataAction.targetItemName);
          break;
        case CONFIGBINDING_ACTION_TYPES.SET_TO_OPTIONS_RESOURCE:
          this.onConfigSetToOptions({ values: null, resource:
                  get(_responseData, element.dataAction.dataFromPath)}, element.dataAction.targetItemName);
          break;
        case CONFIGBINDING_ACTION_TYPES.COPY_TO_FORM_DATA: // add a internal setter to stop reset
          this.onBundleSubscribe(this.getAndWrap(_responseData, element.dataAction), itemKey, true, element.retriggerOther);
          break;
        case CONFIGBINDING_ACTION_TYPES.SET_TO_BINDING_MAP:
          this.setConfigDataToMap(configIdentifier, _responseData);
          break;
        default:
          break;
      }
    });
  }

  private copyFromAnotherIdentifier(_responseData: any, _queries: Array<IdataBinding>) {
    let copyValue: any;
    _queries.forEach(element => {
      if ((element.getFromOtherIdentifiers) && (element.getFromOtherIdentifiers.length)) {
        element.getFromOtherIdentifiers.forEach(Copy => {
          copyValue = get(_responseData, Copy.fromPath);
          set(_responseData, Copy.toPath, copyValue);
        });
      }
    });
    return this.enrichData(_responseData,_queries);
  }

  private getAndWrap(objcet: any, dataAction: IconfigDataAction): any {
    let returnData = { };
    const actualData = dataAction.dataFromPath ? get(objcet, dataAction.dataFromPath) : objcet;
    if (dataAction.dataToPath) {
      set(returnData, dataAction.dataToPath, actualData);
    } else {
      returnData = actualData;
    }

    return returnData;
  }
  protected saveFormData(formId: string, formDataToSave: any): Observable<any> {
    return this.flattenService.flattenProper(formId, formDataToSave, [], true).switchMap((flattenData) => {
      console.log(flattenData[0].formData);
      return this._queryAgregator.UpdateDataToServer([{ formId, formdata: flattenData[0].formData}]);
    });

  }

  private enrichData(responseData: any, dataBindings: Array<IdataBinding>) {
    let enricherDataBindings = dataBindings.filter(dataBinding => !!dataBinding.dataEnricher);
    if (enricherDataBindings.length == 0) {
      return responseData;
    };
    enricherDataBindings.forEach(dataBinding => {
      let dataBindingData = responseData[dataBinding.identifier];
      if(!isEmpty(dataBindingData)){
        /**
         * raw template to assign to data
         */
        let template = dataBinding.dataEnricher.template;
        dataBinding.dataEnricher.pathProvider.forEach(pathProviderItem => {
          let data = get(dataBindingData,pathProviderItem.dataFromPath,null);
          /** transverse to the path in the template and fill with the data from the dataBinding Data
           */
          set(template,pathProviderItem.replaceValueAtPath,data);
        });
        /**
         * targetAssignmentEvaluations are array of items which provide information to a particular
         * path in template and compare with the response data and fill in after merging the data based on
         * the condition to check
         */
        if(!isEmpty(dataBinding.dataEnricher.targetAssignmentEvaluations)) {
          let targetEvaluations = dataBinding.dataEnricher.targetAssignmentEvaluations;
          targetEvaluations.forEach(targetEvaluationItem => {
            if(targetEvaluationItem.templatePath && targetEvaluationItem.isArray) {
              let targetEvaluationData = get(responseData, targetEvaluationItem.templatePath, null);
              if (!isEmpty(targetEvaluationData)) {
                let templateTargetEvaluationData = get(template, targetEvaluationItem.templatePath, null);
                if (!isEmpty(templateTargetEvaluationData)) {
                  /**
                   * Compare a array data for each template array item with each of it's items.
                   * If the data provided by the template is already available in the responseData item with which
                   * comparision is done , that would be discarded otherwise added to the responseData item.
                   */
                  templateTargetEvaluationData.forEach(templateTargetEvaluationDataItem => {
                    let index = findIndex(targetEvaluationData, (value) => {
                      return isEqual(value, templateTargetEvaluationDataItem);
                    });
                    if (index > 0) {
                      remove(templateTargetEvaluationData, (item) => isEqual(item, templateTargetEvaluationDataItem));
                    } else {
                      targetEvaluationData.push(templateTargetEvaluationDataItem);
                    }
                  });
                }
                delete template[targetEvaluationItem.templatePath];
                responseData[targetEvaluationItem.templatePath] = targetEvaluationData;
              }
            }
          });
        }
           responseData = Object.assign({}, responseData , template);
       }
            });
    return responseData;
  }

  /**
   * The function looks for suitable replace action in form data for given form item and replaces item properties
   * by form data
   * @param formData
   * @param formItem
   */
  public replaceActionExecutor(formData: any, formItem: IdynamicFormItem) {
    ReplaceActionService.replace(this._dataBindings, formData, formItem);
  }



}
